module.exports = __webpack_public_path__ + "images/904276b2e92e1722c939cf060a7b1ea8-illu_resolution_door_window.png";